// library
import classNames from "classnames";

import SecondaryButton from "../common/SecondaryButton";
import { OnboardingType } from "./onboarding";
// styles
import styles from "./styles.module.scss";

interface Props {
  onNext: () => void;
  onPrev: () => void;
  steps: number;
  activeStep: number;
  type?: OnboardingType;
}
const OnBoardingStepper = ({
  onNext,
  onPrev,
  steps,
  activeStep,
  type = OnboardingType.LARGE,
}: Props) => {
  const handleNext = () => {
    onNext();
  };

  const handleBack = () => {
    onPrev();
  };

  const array = new Array(steps).fill("");

  return (
    <div
      dir="rtl"
      className={classNames(
        styles.stepper_wrapper,
        type === OnboardingType.SMALL && styles.stepper_wrapper_small
      )}>
      <div className={styles.pointer_wrapper}>
        {array?.map((_, index) => (
          <div
            className={classNames(
              index + 1 === activeStep
                ? styles["pointer_active"]
                : styles["pointer"]
            )}
            key={index}
          />
        ))}
      </div>

      <div style={{ flexDirection: "row" }} className={styles.nav_wrapper}>
        <SecondaryButton disabled={activeStep === 1} onClick={handleBack}>
          <img src="/assets/images/svg/rightArrow.svg" />
        </SecondaryButton>
        <SecondaryButton
          disabled={activeStep === array.length}
          onClick={handleNext}>
          <img src="/assets/images/svg/leftArrow.svg" />
        </SecondaryButton>
      </div>
    </div>
  );
};

export default OnBoardingStepper;
